import { ActionType } from 'typesafe-actions';
import * as actions from './actions';

export enum SessionTypeKeys {
    SET_LANGUAGE = 'session/SET_LANGUAGE',
    SET_USER_INFO = 'session/SET_USER_INFO',
    LOGOUT_USER = 'session/LOGOUT_USER',
    SET_MARKETPLACE_PROPERTIES = 'session/SET_MARKETPLACE_PROPERTIES',
    SET_SESSION_DATA = 'session/SET_SESSION_DATA',
}

export type SessionAction = ActionType<typeof actions>;
